import styled from 'styled-components';
import image_hero_mob from "../../images/mobile/image-hero.jpg"
import image_hero_desk from "../../images/desktop/image-hero.jpg"
export const Container = styled.div`
    background-image: url(${image_hero_mob}) ;
    background-size: cover;
    width: 100vw;
    height: 100vh;
    @media (min-width: 1000px){
        background-image: url(${image_hero_desk});
        background-size: contain;
        background-repeat: no-repeat;
        width: 100vw;
        height: 100vh;
    }
    
`;
